import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';
import Path from '../constants/path';

const ProtectedRoute = ({element}) => {
  const isAuthenticated = sessionStorage.getItem('isLoggedIn');
  const navigate = useNavigate();
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(Path.login, {replace: true});
    } else {
      setShouldRender(true);
    }
  }, [isAuthenticated, navigate]);

  return shouldRender ? element : null;
};

ProtectedRoute.propTypes = {
  element: PropTypes.element.isRequired,
};

export default ProtectedRoute;
